import {Component, Input, OnInit} from '@angular/core';
import {LessonService} from '../../../services/lesson/lesson.service';
import { DropDownAnimation } from './../../../../assets/animations/dropdown';
import {CommonModule} from "@angular/common";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-lesson-item',
  standalone: true,
  imports: [
    CommonModule,
    SafeHtmlPipe,
    TranslateModule
  ],
  templateUrl: './lesson-item.component.html',
  styleUrls: ['./lesson-item.component.scss'],
  animations: [DropDownAnimation]
})

export class LessonItemComponent implements OnInit {

  @Input() lesson: any;
  isOpen: boolean;

  constructor(
    private lessonSrv: LessonService
  ) {
    this.isOpen = false;
  }

  ngOnInit() {
  }

  async download() {
    const base64 = await this.lessonSrv.download(this.lesson.uniqid);
    this.downloadPdf(base64, this.lesson.name);
  }

  downloadPdf(base64String, fileName) {
    const nav = window.navigator as any;
    if (nav && nav.msSaveOrOpenBlob) {
      // download PDF in IE (legacy support)
      let byteChar = atob(base64String);
      let byteArray = new Array(byteChar.length);
      for (let i = 0; i < byteChar.length; i++) {
        byteArray[i] = byteChar.charCodeAt(i);
      }
      let uIntArray = new Uint8Array(byteArray);
      let blob = new Blob([uIntArray], {type: 'application/pdf'});
      nav.msSaveOrOpenBlob(blob, `${fileName}.pdf`);
    } else {
      // Download PDF in Chrome etc.
      const source = `data:application/pdf;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }

  toggleDropdown() {
    if (!this.lesson.content) {
      return;
    }
    this.isOpen = !this.isOpen;
  }
}
